import { useEffect } from 'react';

const SITE_URL = 'https://propdoc.site';
const DEFAULT_TITLE = 'Prop Doc — Section 32 analysis for Victorian property buyers';

// Per-route document metadata for the SPA: keeps the title, description,
// canonical and social tags in sync with the page being viewed so each route
// indexes and shares correctly. Renders nothing.
export default function PageMeta({ title, description, path, noindex }) {
  useEffect(() => {
    const fullTitle = title || DEFAULT_TITLE;
    document.title = fullTitle;
    setMeta('meta[property="og:title"]', fullTitle);
    setMeta('meta[name="twitter:title"]', fullTitle);

    if (description) {
      setMeta('meta[name="description"]', description);
      setMeta('meta[property="og:description"]', description);
      setMeta('meta[name="twitter:description"]', description);
    }

    const url = `${SITE_URL}${path ?? window.location.pathname}`;
    document.querySelector('link[rel="canonical"]')?.setAttribute('href', url);
    setMeta('meta[property="og:url"]', url);

    let robots = document.querySelector('meta[name="robots"]');
    if (noindex) {
      if (!robots) {
        robots = document.createElement('meta');
        robots.setAttribute('name', 'robots');
        document.head.appendChild(robots);
      }
      robots.setAttribute('content', 'noindex');
    } else if (robots) {
      robots.remove();
    }
  }, [title, description, path, noindex]);

  return null;
}

function setMeta(selector, content) {
  document.querySelector(selector)?.setAttribute('content', content);
}
